// removed by extract-text-webpack-plugin
module.exports = {"forgotpassword_form":"_3plXvfAOJdqEGeH0Kb8lM3","email_field":"_1avfxc6-dar7IzuL321_y7","button":"_25LBjVrpgJCaDA1icSpVgp","spinner":"_3UUgvQKKLdkMInPP6aIoim","contentMessage":"_1SwvIai-tq7dGOR56Eit6i","content":"_24uKg3AWBr18o9BeVd6JNX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/ForgotPassword/ForgotPasswordBody/ForgotPasswordBody.scss
// module id = 1786
// module chunks = 0